export default __webpack_public_path__ + "static/media/lock.019f379b.svg";